import { render, staticRenderFns } from "./TraineeSponsorsList.vue?vue&type=template&id=6dae7d5b&"
import script from "./TraineeSponsorsList.vue?vue&type=script&lang=js&"
export * from "./TraineeSponsorsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports